export enum DiscountType {
  Percent = 0, // Default
  Amount = 1,
}

export const DiscountTypeArray = [
  { text: '%', value: DiscountType.Percent },
  { text: 'Amount', value: DiscountType.Amount },
];
